import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import type { ClearCacheResponse } from '../models/ClearCacheResponse';
import type { IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import type { ISortingMeta } from '../models/ISortingMeta';
import type { TPandasTable } from '../models/TPandasTable';
import CoreJsonAPIService from './CoreJsonAPIService';

export default class CachingService extends CoreJsonAPIService {
  static async clearCache() {
    return await super.delete<ClearCacheResponse>(EDjangoAppsEndpoints.cache);
  }

  static async getCaches(params: { page: number; sorting: ISortingMeta }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.cache, '', {
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending
    });
  }

  static async getCache(cacheLabel: string) {
    return await super.get<{ label: string; value: string }>(EDjangoAppsEndpoints.cache, cacheLabel);
  }

  static async deleteCache(cacheLabel: string) {
    return await super.delete<boolean>(EDjangoAppsEndpoints.cache, cacheLabel);
  }
}
